const dedupeRecognitions = (items, windowSec = 3) => {
  if (!Array.isArray(items) || items.length === 0) return []

  const data = items
    .slice()
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))

  const out = []
  const lastSeenMs = new Map()
  const windowMs = windowSec * 1000

  data.forEach((record) => {
    const plate = String(record.plate_number || '')
      .replace(/[-\s]/g, '')
      .toUpperCase()
    const channel = String(record.channel_id ?? '')

    if (!plate || !channel) return

    const timestampMs = new Date(record.created_at).getTime()
    const key = `${channel}|${plate}`
    const prevMs = lastSeenMs.get(key)

    if (prevMs == null || prevMs - timestampMs > windowMs) {
      out.push(record)
      lastSeenMs.set(key, timestampMs)
    }
  })

  return out
}

const dedupeRecognitionsWithCount = (items) => {
  if (!Array.isArray(items) || items.length === 0) return []

  const map = new Map()

  items.forEach((r) => {
    const plate = String(r.plate_number || '')
      .replace(/[-\s]/g, '')
      .toUpperCase()

    if (!plate) return

    const ts = new Date(r.created_at).getTime()
    const prev = map.get(plate)

    if (!prev || ts > prev.createdAtTs) {
      map.set(plate, { ...r, count: (prev?.count || 0) + 1, createdAtTs: ts })
    } else {
      prev.count = (prev.count || 1) + 1
    }
  })

  return Array.from(map.values())
    .map(({ createdAtTs, ...rest }) => rest)
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
}

const TIME_WINDOW_MS = 30 * 1000;
// Объединяем дупликаты одинаковых определений по номеру 
// Объединяем дупликаты которые по времени близки на 30 секунд (в ряд)
// Пушим их в массив relatedEvents
// Выезд и въезд тоже объеденятся, (для реверсивных камер)

const combineDuplicatedRecognitionsWithCount = (eventsList = []) => (eventsList.reduce((acc, previousEvent) => {
  const eventPlateNumber = String(previousEvent.plate_number || '')
  .replace(/[-\s]/g, '')
  .toUpperCase()
  if (!eventPlateNumber) return acc
  const findFilterFn = (e) => e.plate_number === eventPlateNumber //&& previousEvent.channel_id === e.channel_id
  
  const earliestEventIndex = acc.findLastIndex(findFilterFn);
  // increase count of last event if previous event is duplicate recognition
  if (earliestEventIndex >=0) { 
    const earliestEvent = acc[earliestEventIndex];
    const lastRelatedEvent = earliestEvent.relatedEvents[earliestEvent.relatedEvents.length - 1];
    const previousEventTimestampMs = new Date(previousEvent.created_at).getTime();
    const earliestEventTimestampMs = new Date((lastRelatedEvent ?? earliestEvent)['created_at']).getTime();
    if (earliestEventTimestampMs - previousEventTimestampMs <= TIME_WINDOW_MS){
      earliestEvent.relatedEvents.push(previousEvent);
      return acc;
    }
  }
  acc.push({ ...previousEvent, relatedEvents: [] })
  return acc;
}, []))

export {
  dedupeRecognitions,
  dedupeRecognitionsWithCount,
  combineDuplicatedRecognitionsWithCount,
}
